import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('side-panel', {
  root: {
    variants: {
      skin: ['standard', 'floating'],
    },
    states: ['hideOverflow'],
  },
});
